module.exports = __webpack_public_path__ + "static/img/kd100_visitor_header_bg.f61d41a1.png";